/** @format */

import React from 'react';

export default function MadnessPg(props) {
  return <div style={{backgroundColor:'black'}}>
            <img class="Sirv" data-src="https://cdn.sunsh1n3.com/Images/misc/ColorMadness_Bracket.jpg" />
         </div>;
}
